<div class="alcolock-container">
  <div class="page-header">
    <h1>Röda blåsningar</h1>
    <div class="header-controls">

      <div class="compact-stat">
        <div class="stat-number">{{ statistics.failedCount }}
          <span class="stat-label">Ej godkända test</span>
        </div>
      </div>
      <div class="time-filter">
        <select [(ngModel)]="selectedTimeRange" (change)="onTimeRangeChange()" [disabled]="isLoading">
          <option value="24">Senaste 24h</option>
          <option value="48">Senaste 48h</option>
          <option value="72">Senaste 72h</option>
        </select>
      </div>
      <button
        mat-raised-button
        color="primary"
        class="search-button"
        (click)="loadData()"
        [disabled]="isLoading"
        title="Uppdatera data">
        <mat-icon [class.spinner]="isLoading">refresh</mat-icon>
        {{ isLoading ? 'Laddar...' : 'Uppdatera' }}
      </button>
    </div>
  </div>


  @if (isLoading) {
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p>Laddar alkoholtest data...</p>
    </div>
  }

  @if (!isLoading) {
    <div class="results-table-container">
      @if (testResults.length > 0) {
        <table class="results-table">
          <thead>
            <tr>
              <th>Tidpunkt</th>
              <th>Namn</th>
              <th>Anställd ID</th>
              <th>Lokförare</th>
              <th>Avdelning</th>
              <th>Resultat</th>
            </tr>
          </thead>
          <tbody>
            @for (result of testResults; track result) {
              <tr
                (click)="onRowClick(result)"
                [class]="'result-' + result.displayResult"
                [class.highlight-failed]="result.displayResult === 'fail'"
                [class.selected]="isRowSelected(result.id)"
                style="cursor: pointer;">
                <td>{{ formatTimestamp(result.timeStamp) }}</td>
                <td>
                  @if (isRowSelected(result.id)) {
                    <span class="employee-name">{{ getEmployeeName(result) }}</span>
                  } @else {
                    <span class="masked-identity">
                      <span class="masked-text">••••••••••</span>
                    </span>
                  }
                </td>
                <td>
                  @if (isRowSelected(result.id)) {
                    {{ result.employeeId }}
                  } @else {
                    <span class="masked-identity">
                      <span class="masked-text">••••••••••</span>
                    </span>
                  }
                </td>
                <td>
                  @if (isRowSelected(result.id)) {
                    {{ result.isTrainDriver === true ? 'Ja' : result.isTrainDriver === false ? 'Nej' : '-' }}
                  } @else {
                    <span class="masked-identity">
                      <span class="masked-text">••••••••••</span>
                    </span>
                  }
                </td>
                <td>
                  @if (isRowSelected(result.id)) {
                    <span [class]="result.department ? 'department' : 'no-department'">
                      {{ result.department }}
                    </span>
                  } @else {
                    <span class="masked-identity">
                      <span class="masked-text">••••••••••</span>
                    </span>
                  }
                </td>
                <td>
                  <span class="result-badge" [class]="result.displayResult">
                    <span class="result-icon">{{ result.resultIcon }}</span>
                    {{ result.resultText }}
                  </span>
                  @if (isRowSelected(result.id) && isRowLoading) {
                    <span class="loading-inline">⟳</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (testResults.length === 0) {
        <div class="no-results">
          <h3>Inga testresultat hittades</h3>
          <p>Det finns inga alkoholtest i den valda tidsperioden.</p>
        </div>
      }
    </div>
  }
